import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { SessionService } from '../../Util/Session/session.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modules-list',
  standalone: true,
  imports: [CommonModule,LoaderComponent, RouterModule],
  templateUrl: './modules-list.component.html',
  styleUrl: './modules-list.component.scss'
})
export class ModulesListComponent {
  isDisabled: boolean = false;
  constructor(
    private router: Router,
    private toast: ToastService,
    private utility: UtilityService,
    private session: SessionService
  ) { 
    this.User = session.GetUserDetails();
  }

  User: any;
  ModuleTrfr(type: number) {
    if (type == 2) {//Administration
      this.ESS_CentralizedLoginKeyGeneration('administrator');
    } else if (type == 3) {//ESS
      this.router.navigate(['dashboard/front'], { replaceUrl: true })
    } else if (type == 4){ //OnBoarding
      this.ESS_CentralizedLoginKeyGeneration('onboarding');
    }
    else {
      this.toast.show({ message: "Module access not allow kinfy contact adminstrator", type: toastTypeEnum.danger });
    }
  }

  ESS_CentralizedLoginKeyGeneration(moduleName: String) {
    this.isDisabled = true;
    return this.utility.ESS_CentralizedLoginKeyGeneration({ 'SelectType': 'I', 'ModuleName': moduleName, 'JSON': JSON.stringify(this.User) }).subscribe({
      next: (response) => {
        if (response.Error_Code == '01' && response.Key != null && response.Key != '') {
          if (moduleName == 'administrator') {
            //console.log("https://maxedgeadmin.maxus.co.in/Login/" + response.Key);
            // window.open("https://maxusadmin.maxus.co.in/login/" + response.Key, "_blank");
            window.open(this.User.AdministrationURL + 'login/' + response.Key, "_blank");
          }
          else if(moduleName == 'onboarding'){
            window.open("https://maxusregistration.maxus.co.in/login/" + response.Key, "_blank");
          }
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  routeBack(){
    this.router.navigate(['/dashboard/front'])
  }
}